var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoordinationRequired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43527",
    "data-name": "Group 43527",
    transform: "translate(-194 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16123",
    "data-name": "Rectangle 16123",
    width: 24,
    height: 24,
    transform: "translate(194 80)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "unity",
    transform: "translate(180.5 66.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43528",
    "data-name": "Group 43528",
    transform: "translate(15 27.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37249",
    "data-name": "Path 37249",
    d: "M15,407.348h7.009v-1.072A3.012,3.012,0,0,0,19,403.264h-.985A3.012,3.012,0,0,0,15,406.276Z",
    transform: "translate(-15 -399.195)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3140",
    "data-name": "Ellipse 3140",
    cx: 2.035,
    cy: 2.035,
    rx: 2.035,
    ry: 2.035,
    transform: "translate(1.364 0)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37250",
    "data-name": "Path 37250",
    d: "M175.875,407.348h7.009v-1.072a3.012,3.012,0,0,0-3.012-3.012h-.985a3.012,3.012,0,0,0-3.012,3.012Z",
    transform: "translate(-168.866 -399.195)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3141",
    "data-name": "Ellipse 3141",
    cx: 2.035,
    cy: 2.035,
    rx: 2.035,
    ry: 2.035,
    transform: "translate(8.373 0)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37251",
    "data-name": "Path 37251",
    d: "M336.125,407.348h7.009v-1.072a3.012,3.012,0,0,0-3.012-3.012h-.985a3.012,3.012,0,0,0-3.012,3.012Z",
    transform: "translate(-322.134 -399.195)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3142",
    "data-name": "Ellipse 3142",
    cx: 2.035,
    cy: 2.035,
    rx: 2.035,
    ry: 2.035,
    transform: "translate(15.355 0)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37252",
    "data-name": "Path 37252",
    d: "M36,15H15v8.029h2.189l1.21,1.9,1.21-1.9H24.29l1.21,1.9,1.21-1.9h4.47l1.21,1.9,1.21-1.9H36Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43529",
    "data-name": "Group 43529",
    transform: "translate(21.488 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37253",
    "data-name": "Path 37253",
    d: "M299.782,15v2.7h-.887a1.313,1.313,0,0,0-1.313,1.313h0a1.313,1.313,0,0,0,1.313,1.313h.887v2.7",
    transform: "translate(-291.759 -15)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37254",
    "data-name": "Path 37254",
    d: "M163.925,15v2.7h.887a1.313,1.313,0,0,1,1.313,1.313h0a1.313,1.313,0,0,1-1.313,1.313h-.887v2.7",
    transform: "translate(-163.925 -15)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoordinationRequired);
export default __webpack_public_path__ + "static/media/coordination-required.95b8d6e98409118c78e16da37b4fd90e.svg";
export { ForwardRef as ReactComponent };